import { matchesAttribute } from './matchesImageCollection';

export default function getVariantPayload({
  variant,
  shopifyProduct,
  productData,
  additionalProducts
}) {
  const discountAmount =
    parseInt(variant?.compareAtPrice?.amount, 10) -
      parseInt(variant?.price?.amount, 10) >
    0
      ? parseInt(variant?.compareAtPrice?.amount, 10) -
        parseInt(variant?.price.amount, 10)
      : parseInt(variant?.compareAtPrice?.amount, 10) -
        parseInt(variant?.price?.amount, 10);

  // Set cart thumbnail, if image collections exist, get thumbnail for matching
  // color collection or matching size collection. By the way, note for bundles
  // there is be no "size" or "secondAttr" within image_collections.

  const imageCollections = productData?.product_images?.image_collections || [];

  const size = variant?.selectedOptions.find(
    (option) => option.name == 'Size'
  )?.value;
  const secondAttr = variant?.selectedOptions.find(
    (option) => option.name !== 'Size'
  );

  const firstCollectionThumb = imageCollections?.[0]?.thumbnail?.url || '';
  let productThumbnail = '';
  let collectionImages;

  if (imageCollections.length) {
    // Matching: Size + Secondary Attribute combination highest priority
    if (size && secondAttr) {
      collectionImages = imageCollections.find((image) => {
        const sizeMatches = Array.isArray(image?.size)
          ? image.size.includes(size)
          : image?.size === size;

        const secondaryMatches = matchesAttribute(
          image,
          secondAttr.name,
          secondAttr.value
        );

        return sizeMatches && secondaryMatches;
      });
    }

    // Fallback 1: Size-only match
    if (!collectionImages && size) {
      collectionImages = imageCollections.find((image) =>
        Array.isArray(image?.size)
          ? image.size.includes(size)
          : image?.size === size
      );
    }

    // Fallback 2: Secondary attribute only match
    if (!collectionImages && secondAttr) {
      collectionImages = imageCollections.find((image) =>
        matchesAttribute(image, secondAttr.name, secondAttr.value)
      );
    }

    productThumbnail =
      collectionImages?.thumbnail?.url ||
      firstCollectionThumb ||
      shopifyProduct?.featuredImage?.url ||
      variant?.image?.url;
  } else {
    // No collections: use product/variant images
    productThumbnail =
      shopifyProduct?.featuredImage?.url || variant?.image?.url;
  }

  // detect if there's a bundle offer item, and if so we'll add/remove custom attributes
  const bundleOfferProduct = additionalProducts?.find((product) =>
    product.customAttributes.find((attribute) => attribute.key == 'Bundle')
  );

  let variantPayload;

  if (bundleOfferProduct !== undefined) {
    variantPayload = {
      compareAtPrice: variant?.compareAtPrice?.amount
        ? variant?.compareAtPrice?.amount
        : variant?.compareAtPrice,
      customAttributes:
        [
          { key: '_discount_amount', value: (discountAmount * 100).toString() },
          { key: '_productImage', value: productThumbnail },
          { key: '_productPosition', value: '0' },
          {
            key: '_productType',
            value: shopifyProduct?.productType || shopifyProduct[0]?.productType
          },
          { key: '_compareAtPrice', value: variant?.compareAtPrice?.amount },
          {
            key: 'Bundle',
            value: bundleOfferProduct?.customAttributes?.find(
              (attribute) => attribute?.key == 'Bundle'
            )?.value
          },
          {
            key: '_bundleVariant',
            value: bundleOfferProduct?.customAttributes?.find(
              (attribute) => attribute?.key == '_bundleVariant'
            )?.value
          },
          {
            key: '_bundleHandle',
            value: `/products/${shopifyProduct?.handle}`
          },
          {
            key: '_bundleId',
            value: bundleOfferProduct?.customAttributes?.find(
              (attribute) => attribute?.key == '_bundleId'
            )?.value
          },
          {
            key: '_gwpParentProduct',
            value: 'true'
          },
          {
            key: '_bundleDiscountAmount',
            value: '0'
          }
        ].filter((attr) => attr?.value !== undefined && attr?.value !== null) ||
        [],
      handle: shopifyProduct?.handle,
      id: variant?.id,
      image: productThumbnail,
      price: variant?.price?.amount ? variant?.price?.amount : variant?.price,
      productTitle: shopifyProduct?.title,
      productId: shopifyProduct?.id,
      variantTitle: variant?.title || variant?.variantTitle,
      sku: variant?.sku,
      type: shopifyProduct?.productType || shopifyProduct[0]?.productType,
      quantity: 1,
      lineItemId: '',
      outOfStock: variant?.outOfStock,
      selectedOptions: variant?.selectedOptions
    };
  } else {
    variantPayload = {
      compareAtPrice: variant?.compareAtPrice?.amount
        ? variant?.compareAtPrice?.amount
        : variant?.compareAtPrice,
      customAttributes:
        [
          { key: '_discount_amount', value: (discountAmount * 100).toString() },
          { key: '_productImage', value: productThumbnail },
          { key: '_productPosition', value: '0' },
          {
            key: '_productType',
            value: shopifyProduct?.productType || shopifyProduct[0]?.productType
          },
          { key: '_compareAtPrice', value: variant?.compareAtPrice?.amount }
        ].filter((attr) => attr?.value !== undefined && attr?.value !== null) ||
        [],
      handle: shopifyProduct?.handle,
      id: variant?.id,
      image: productThumbnail,
      price: variant?.price?.amount ? variant?.price?.amount : variant?.price,
      productTitle: shopifyProduct?.title,
      productId: shopifyProduct?.id,
      variantTitle: variant?.title || variant?.variantTitle,
      sku: variant?.sku,
      type: shopifyProduct?.productType || shopifyProduct[0]?.productType,
      quantity: 1,
      lineItemId: '',
      outOfStock: variant?.outOfStock,
      selectedOptions: variant?.selectedOptions
    };
  }
  return variantPayload;
}
